import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbNavigation = ({ userRole = 'admin' }) => {
  const location = useLocation();

  const getPageTitle = (pathname, role) => {
    const pageMap = {
      '/login-screen': 'Login',
      '/master-admin-dashboard': 'Master Admin Dashboard',
      '/clab-dashboard': 'CLAB Dashboard',
      '/recruiter-biodata-management': 'Biodata Management',
      '/employer-biodata-selection': 'Worker Selection',
      '/user-management': 'User Management',
      '/clab-user-biodata-review': 'Biodata Review',
      '/clab-biodata-pending': 'Pending Reviews',
      '/clab-biodata-drafts': 'Draft Biodata',
      '/clab-biodata-approved': 'Approved Biodata',
      '/clab-biodata-rejected': 'Rejected Biodata',
      '/clab-biodata-amended': 'Amended Biodata',
      '/clab-biodata-shortlisted': 'Shortlisted Workers',
      '/clab-selection-requests': 'Selection Requests',
      '/clab-reports-analytics': 'Reports & Analytics',
      '/employer-dashboard': 'Employer Dashboard',
      '/employer-application-management': 'Application Management',
      '/employer-special-quota/new': 'New Special Quota',
      '/employer-special-quota': 'Special Quota Details',
      '/employer-vdr-applications': 'VDR Applications',
      '/employer-browse-workers': 'Selected Workers',
      '/employer-approved-workers': 'Selected Workers',
      '/employer-shortlist': 'Shortlisted Workers',
      '/admin-settings': 'Admin Settings',
      '/clab-settings': 'CLAB Settings',
      '/recruiter-settings': 'Recruiter Settings'
    };
    if (pathname.startsWith('/employer-special-quota')) {
      return 'Special Quota';
    }
    return pageMap[pathname] || 'Page';
  };

  const getBreadcrumbItems = (pathname, role) => {
    // Determine the correct home path based on user role
    const getHomePath = (role) => {
      const roleHomePaths = {
        'admin': '/master-admin-dashboard',
        'master_admin': '/master-admin-dashboard',
        'clab': '/clab-dashboard',
        'clab_user': '/clab-dashboard',
        'recruiter': '/recruiter-biodata-management',
        'employer': '/employer-dashboard'
      };
      return roleHomePaths[role] || '/clab-dashboard';
    };

    const homePath = getHomePath(role);
    const items = [
      { label: 'Home', path: homePath, icon: 'Home' }
    ];

    // Don't show breadcrumbs for login or dashboard pages
    const dashboardPaths = ['/login-screen', '/master-admin-dashboard', '/clab-dashboard', '/recruiter-biodata-management', '/employer-dashboard'];
    if (dashboardPaths.includes(pathname)) {
      return [];
    }

    // Add current page
    const currentPageTitle = getPageTitle(pathname, role);
    if (currentPageTitle !== 'Page') {
      items.push({
        label: currentPageTitle,
        path: pathname,
        current: true
      });
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems(location.pathname, userRole);

  // Don't render breadcrumbs if there are no items or only home
  if (breadcrumbItems.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbItems.map((item, index) => (
          <li key={item.path} className="flex items-center">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-secondary-400 mx-2" 
              />
            )}
            
            {item.current ? (
              <span className="flex items-center text-text-primary font-medium">
                {item.icon && (
                  <Icon 
                    name={item.icon} 
                    size={16} 
                    className="mr-2 text-secondary-500" 
                  />
                )}
                {item.label}
              </span>
            ) : (
              <Link
                to={item.path}
                className="flex items-center text-secondary-600 hover:text-primary transition-colors duration-150 micro-interaction"
              >
                {item.icon && (
                  <Icon 
                    name={item.icon} 
                    size={16} 
                    className="mr-2" 
                  />
                )}
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;
